import { pageModule } from '@components/pageModule';
import { each } from 'lodash';

export interface TabType {
    index: number;
    key: string;
    label: string;
    listed: boolean;
    defaultState: any;
    Component: any;
    hideTabs: boolean;
    disabled: boolean;
}

const TABS: Partial<TabType>[] = [
    {
        key: 'products',
        label: 'Products',
        defaultState: {
            category_id: 0,
            category_name: null,
            packages: {},
            extras: {},
        },
        Component: () => pageModule(import('./Products')),
    },
    {
        key: 'colors',
        label: 'Colors',
        defaultState: {
            colors: [],
            primary_colors: [],
            secondary_colors: [],
            custom_pantone_codes: [],
        },
        Component: () => pageModule(import('./Colors')),
    },
    {
        key: 'uploads',
        label: 'Uploads',
        defaultState: {
            logos: [],
            uniforms: [],
            other_images: [],
        },
        Component: () => pageModule(import('./Images')),
    },
    {
        key: 'description',
        label: 'Description',
        defaultState: {
            description: '',
            design_themes: [],
            athletes_count: '',
            first_event_date: '',
            target_in_hand_date: '',
            process_stage: '',
        },
        Component: () => pageModule(import('./Description')),
    },
    {
        key: 'review',
        label: 'Review',
        defaultState: {
            name: '',
            due_date: '',
            categories: [],
            nfhs: null,
            team_name: '',
        },
        Component: () => pageModule(import('./Review')),
    },
];

export function tabsHelperMaker(TABS) {
    return {
        /**
         * Tab list
         */
        _items: TABS.map((t: Partial<TabType>, nth: number) => {
            t.index = nth;
            return t;
        }) as TabType[],

        /**
         * Get All tabs as array
         */
        all(): TabType[] {
            return this._items as any;
        },

        /**
         * Get all tabs that can be listed
         * @returns {Array<TabType>}
         */
        listedTabs(): TabType[] {
            return this.all().filter((tab$: TabType) => tab$.listed);
        },

        first() {
            return this.all()[0];
        },

        /**
         * Get Tab by index, key or tab object.
         * @param index
         * @returns {*}
         */
        get(index: number | string | Partial<TabType>): TabType | null {
            let el: TabType | null = null;

            if (typeof index === 'object') {
                index = index.index as any;
            }

            if (typeof index === 'string') {
                each(this._items, (tab$) => {
                    if (tab$.key === index) {
                        el = tab$;
                        return false;
                    }
                });
            } else if (typeof index === 'number') {
                each(this._items, (tab$: TabType) => {
                    if (tab$.index === index) {
                        el = tab$;
                        return false;
                    }
                });
            }

            return el;
        },
        /**
         * Check if tab exist
         * @param value
         * @returns {boolean}
         */
        has(value: number | string | TabType): boolean {
            return !!this.get(value);
        },

        /**
         * Get index of tab
         * @param tab
         * @returns {number}
         */
        indexOf(tab: number | string | TabType): number {
            const tab$ = this.get(tab);
            return tab$ !== null ? tab$.index : -1;
        },
    };
}

const tabs$ = tabsHelperMaker(TABS);

export default tabs$;
